module.exports = __webpack_public_path__ + "fonts/yellow-bell.svg";